import * as React from 'react';
import Box from '@mui/material/Box';
import SidebarMenu from './SidebarMenu';
import '../css/reset.css';
import '../css/layout.css';
import '../css/common.css';
import '../css/style.css';
import '../css/dashboard.css';
import '../css/lnb.css';
import { WeatherPaper } from 'pages/components/WeatherPaper';
import { SwItsGetDangerVehicleProvider, SwItsDangerVehicleTotalInfo } from 'pages/components/dashboard/SwItsGetDangerVehicle';
import { SwItsGetRoadStatTotalProvider, SwItsGetRoadStatInfo, SwItsGetRoadStatLine } from 'pages/components/dashboard/SwItsGetRoadStat';
import { SwItsGetEvntDetailProvider, SwItsGetEvntDetailInfo, SwItsGetEvntDetailChart, SwItsGetEvntDetailTotalCntInfo, SwItsGetEvntDetailDetectedTotalCntInfo } from 'pages/components/dashboard/SwItsGetEvntDetail';
import { useTranslation } from 'react-i18next';
//const onlyDetectCodes = [4387, 4417, 4597,4596,4594, 4450, 4420, 4388, 4358]; // 검지 서칭용 이벤트
const onlyDetectCodes =[4358, 4450 , 4418]; // 위험행동 - 정지선 위반, 꼬리물기, 정지차량 
// const outBreakCodes = [4387, 4417, 4418, 4595] // 돌발 
const outBreakCodes = [4417,4387, 4595] // 돌발 위험상황 - 역주행, 무단횡단 , 사고 

export default function TrafficSafetyViewD() {
  React.useEffect(() => { }, []);
   const { t, i18n } = useTranslation();
  
    const toggleLanguage = () => {
      const newLang = i18n.language === 'ko' ? 'en' : 'ko';
      i18n.changeLanguage(newLang);
    };
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <div className="dashboard container flx a_center">
        <SidebarMenu />
        <div className="ctrlMain">
          <div className="mainTit flx j_spc_btw a_center">
            <div className="titBox">
               <p
                className={`subTit${i18n.language === 'en' ? '_en' : ''}`}
                onClick={toggleLanguage}
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                {t('subtitle')}
              </p>
              <p className={`tit${i18n.language === 'en' ? '_en' : ''}`}>
                {t('mainTitle5')}
              </p>
            </div>
            <div className="weatherWrap flx a_center j_spc_btw">
              <WeatherPaper /> {/* sx는 필요에 맞게 조정 */}
            </div>
          </div>
          <div className="mainInfo L_lr">
            {/*메인박스*/}
            <div className="L_2m L_tb">
              <div className="L_d inner flx flx_col j_spc_btw">
                <div className="titWrap flx j_spc_btw">
                 <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`}  style={{color:'var(--iv-02)'}}>
                   {t('HazardousMaterialsVehicleStatus')}
                    </h2>
                </div>
                <div className="dangVehConts">
                  <SwItsGetDangerVehicleProvider>
                    <SwItsDangerVehicleTotalInfo />
                  </SwItsGetDangerVehicleProvider>
                </div>
              </div>
              <div className="L_d inner flx flx_col j_spc_btw">
                <div className="titWrap flx j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-05)'}}>{t('RoadSurfaceCondition')}
                  </h2>
                </div>
                <div className="rdStusConts">
                  <SwItsGetRoadStatTotalProvider>
                    <SwItsGetRoadStatInfo/>
                    <SwItsGetRoadStatLine />
                  </SwItsGetRoadStatTotalProvider>
                  {/* <div className='spkActiveBox'>
                    <div className='imgBox'></div>
                  </div> */}
                </div>
              </div>
            </div>
                <SwItsGetEvntDetailProvider>
            <div className="L_2m flx flx_col j_spc_btw">
              <div className="L_d inner flx flx_col j_spc_btw">
                  <div className="titWrap flx j_spc_btw">
                    <SwItsGetEvntDetailTotalCntInfo />
                  </div>
                  <div className="unxpConts flx a_center">
                    <div className="unxpchart">
                    <SwItsGetEvntDetailChart isInclude={false} className={'dashChart'} targetCodes={outBreakCodes} />
                    </div>
                    <div className="unxpGrid flx flx_col j_spc_btw">
                     <SwItsGetEvntDetailInfo
                        isInclude={false}           // 돌발코드만 
                        targetCodes={outBreakCodes}
                      /> 
                    </div>
                  </div>
              </div>
              <div className="L_d inner flx flx_col j_spc_btw">
                  <div className="titWrap flx j_spc_btw">
                    <SwItsGetEvntDetailDetectedTotalCntInfo />
                  </div>
                  <div className="unxpConts flx a_center">
                    <div className="unxpchart">
                      <SwItsGetEvntDetailChart className={'dashChart'} isInclude={true} targetCodes={onlyDetectCodes}/>
                    </div>
                    <div className="unxpGrid flx flx_col j_spc_btw">
                    <SwItsGetEvntDetailInfo
                        isInclude={true}          // 검지 코드만 
                        targetCodes={onlyDetectCodes}
                      />
                    </div>
                  </div>
              </div>
            </div>
                </SwItsGetEvntDetailProvider>
          </div>
        </div>
      </div>
    </Box>
  );
}
